
import React from 'react';
import './App.css';
import Header from "./components/utilities/Header/Header.jsx";
import Footer from "./components/utilities/Footer/Footer.jsx";
import Temporaryblankbox from "./components/utilities/Temporaryblankbox.jsx";
import Landinglayoutbox from "./components/utilities/Landinglayout.jsx";


function Apoo() {
  return (
    <div className="App">
      <Header/>

      <Landinglayoutbox/>


      <Footer/>
    </div>
  );
}

export default Apoo;
